export default {
  home: {
    title: '首页',
    aiBannerTxt: {
      title:'让AI教育落地',
      subtitle:'AI+教育数智化赋能，融合创新理念',
      description:'专注激光定制化产品和技术服务，助力院校&企业融合【AI+教育】'
    },
    description: '欢迎访问我们的Vue.js营销网站',
    banner: {
      slide1: {
        title: 'STEAM 套件 | 人工智能套件 | 激光切割套件',
        description:
          '我们为家庭、教育工作者和分销商提供创新的 STEAM 教育解决方案和各类套件，专为 3 至 16 岁的儿童设计。',
      },
      slide2: {
        title: '专业套件，专为孩子的创新力而设计',
        description: '课程、设备与软件一体化，轻松开展项目式学习',
      },
      slide3: {
        title: '面向未来的科技教育',
        description: '动手实践、跨学科融合，培养问题解决与协作能力',
      },
    },
    factory: {
      banner: {
        alt: '智能工厂横幅',
        title: '智能工厂解决方案',
        description: '生产线搭建｜工业传感｜PLC 控制与数据采集',
        image: 'https://picsum.photos/seed/factory-banner/1000/600',
      },
      resourcesTitle: '教学资源',
      resources: [
        {
          title: '项目式教学资料',
          desc: '课程PPT与讲义、课堂活动设计与评价建议。',
          image: 'https://picsum.photos/seed/factory-res-1/374/217',
        },
        {
          title: '场景示例与素材',
          desc: '传送带控制、工位检测、设备联动等示例与代码片段。',
          image: 'https://picsum.photos/seed/factory-res-2/374/217',
        },
        {
          title: '课后拓展任务',
          desc: '延伸任务与跨学科应用建议，促进探究与创作。',
          image: 'https://picsum.photos/seed/factory-res-3/374/217',
        },
      ],
      intro: {
        title: '产品简介',
        desc: '智能工厂方案以生产线搭建与编程控制为核心，涵盖工业传感、工位识别、PLC/单片机控制与数据采集等内容，强调实践与系统训练。',
        bg: 'https://picsum.photos/seed/factory-bg/1200/736',
      },
      course: {
        title: '配套的课程',
        desc: '围绕生产线搭建、工业传感、PLC 控制与数据采集等主题设计项目式课程，强调实操与系统训练。',
        image: 'https://picsum.photos/seed/factory-course/668/597',
      },
      equipments: [
        {
          title: '输送带模块',
          image: 'https://picsum.photos/seed/factory-eq-1/209/209',
        },
        {
          title: '光电传感器',
          image: 'https://picsum.photos/seed/factory-eq-2/209/209',
        },
        {
          title: 'PLC 控制单元',
          image: 'https://picsum.photos/seed/factory-eq-3/209/209',
        },
        {
          title: '机械臂模块',
          image: 'https://picsum.photos/seed/factory-eq-4/209/209',
        },
        {
          title: '条码识别模块',
          image: 'https://picsum.photos/seed/factory-eq-5/209/209',
        },
        {
          title: '温湿度传感器',
          image: 'https://picsum.photos/seed/factory-eq-6/209/209',
        },
        {
          title: '电机驱动模块',
          image: 'https://picsum.photos/seed/factory-eq-7/209/209',
        },
        {
          title: '工位检测模块',
          image: 'https://picsum.photos/seed/factory-eq-8/209/209',
        },
        {
          title: '安全急停模块',
          image: 'https://picsum.photos/seed/factory-eq-9/209/209',
        },
        {
          title: '数据采集网关',
          image: 'https://picsum.photos/seed/factory-eq-10/209/209',
        },
      ],
    },
    solutions: {
      title: 'Zetok STEAM教育解决方案',
      learnMore: '了解更多 >',
      items: [
        {
          image: require('@/assets/home/solution1.webp'),
          title: 'Zetok套件',
          description:
            '通过实践操作和项目式学习，培养了他们的创新思维和实践能力。',
          link: '/solutions/kits',
        },
        {
          image: require('@/assets/home/solution2.webp'),
          title: 'Good Laser 激光切割机&雕刻机',
          description: '激光切割机为STEAM教育带来了全新的实践学习体验',
          link: '/solutions/laser',
        },
      ],
    },
    scenes: {
      title: '教学场景',
      items: [
        {
          image: require('@/assets/home/education1.webp'),
          title: 'STEM教育解决方案',
        },
        {
          image: require('@/assets/home/education2.webp'),
          title: '创客空间解决方案',
        },
      ],
    },
    aiBanner: {
      alt: 'AI Banner',
      image: require('@/assets/home/aibanner.png'),
    },
    kitsSection: {
      alt: 'Zetok 套件',
      title: '人工智能套件',
      description:
        '人工智能套件通常包含丰富的互动和实践项目，能够激发学生对科技的兴趣和好奇心。',
      image: require('@/assets/home/kitsbanner.png'),
    },
    kitsCarousel: {
      alt: '套件轮播',
      title: '提升创新思维',
      items: [
        { image: require('@/assets/home/kits1.png') },
        { image: require('@/assets/home/kits2.png') },
        { image: require('@/assets/home/kits3.png') },
        { image: require('@/assets/home/kits4.png') },
        { image: require('@/assets/home/kits5.png') },
        { image: require('@/assets/home/kits6.png') },
        { image: require('@/assets/home/kits7.png') },
        { image: require('@/assets/home/kits8.png') },
        { image: require('@/assets/home/kits9.png') },
      ],
    },
    products: {
      title: 'Zetok套件与Good Laser激光切割机',
      tabs: {
        kits: '套件',
        courses: '课程',
        laser: '激光设备',
        software: '软件',
      },
      items: {
        kits: [
          {
            image: require('@/assets/home/product1.webp'),
            title: '激光切割入门套件',
            description: '(配套木板耗材)',
          },
          {
            image: require('@/assets/home/product2.webp'),
            title: '奇妙科学宝盒',
            description: '(配套木板+微电路套件包)',
          },
          {
            image: require('@/assets/home/product3.webp'),
            title: '人工智能编程套件',
            description: '',
          },
        ],
        courses: [
          {
            image: require('@/assets/home/product4.webp'),
            title: '科学探索体系-幼儿',
            description: '（6门课）',
          },
          {
            image: require('@/assets/home/product5.webp'),
            title: 'STEAM创客体系青少年',
            description: '（3门课）',
          },
          {
            image: require('@/assets/home/product6.webp'),
            title: '激光切割课程',
            description: '（3门课）',
          },
          {
            image: require('@/assets/home/product7.webp'),
            title: '人工智能课程体系',
            description: '（4门课）',
          },
        ],
        laser: [
          {
            image: require('@/assets/home/product8.png'),
            title: 'Light 530 ',
            description: '55W桌面式Co2激光切割机&雕刻机',
          },
          {
            image: require('@/assets/home/product9.png'),
            title: 'Light 640',
            description: '专业台式激光切割机&雕刻机',
          },
          {
            image: require('@/assets/home/product10.png'),
            title: 'Light Blue 530 ',
            description: '智能桌面式蓝光激光切割机&雕刻机',
          },
          {
            image: require('@/assets/home/product11.png'),
            title: 'Mark M20',
            description: '高精度激光打标机',
          },
        ],
        software: [
          {
            image: require('@/assets/home/product12.png'),
            title: 'Zetok学习平台',
            description: '',
          },
          {
            image: require('@/assets/home/product13.png'),
            title: 'Zetok云平台',
            description: '',
          },
          {
            image: require('@/assets/home/product14.png'),
            title: 'Light Maker',
            description: '',
          },
          {
            image: require('@/assets/home/product15.png'),
            title: 'mind+',
            description: '',
          },
          {
            image: require('@/assets/home/product16.png'),
            title: 'Arduino',
            description: '',
          },
        ],
      },
    },
  },
  switch_lang: 'English',
  nav: {
    products: '产品',
    smartFarm: '智能农场',
    smartHome: '智能家居',
    smartTraffic: '智能交通',
    smartFactory: '智能工厂',
    laserSteam: '激光切割 STEAM 套件',
    dreamScience: '逐梦科学套件',
    course: '课程',
    device: '设备',
    education: '教育方案',
    stem: 'STEM教育解决方案',
    maker: '创客空间解决方案',
    software: '软件',
    service: '服务与支持',
    afterSale: '教程下载',
    about: '关于我们',
    aboutUs: '关于我们',
    dealer: '成为我们的经销商',
    cooperation: '产品使用与教育合作',
    news: '新闻',
    coursesSeries: '四大课程系列',
    viewMore: '查看更多',
    store: "商店"
  },
  globalContactForm: {
    title: '联系我们',
    subtitle: '有任何问题或需求，请随时与我们联系，我们将竭诚为您服务',
    fields: {
      name: '姓名',
      email: '邮箱',
      phone: '电话',
      company: '公司',
      message: '留言',
    },
    placeholders: {
      name: '请输入姓名',
      email: '请输入邮箱地址',
      phone: '请输入联系电话',
      company: '请输入公司名称',
      message: '请填写你的需求或问题',
    },
    validation: {
      name: '请输入姓名',
      email: '请输入邮箱地址',
      emailFormat: '邮箱格式不正确',
      phone: '请输入联系电话',
      message: '请填写留言',
    },
    submit: '提交',
    submitting: '提交中…',
    visual: {
      title: '专业服务',
      description:
        '专注3-16岁儿童科技创造力教育，开设科创空间，研发相关产品与课程。',
    },
    contact: {
      phone: '服务热线',
      email: '邮箱地址',
    },
  },
  thankYou: {
    metaTitle: '感谢您的提交',
    title: '感谢您的提交！',
    description: '我们已收到您的信息，会尽快与您联系。',
    seoDescription: '提交成功，我们的团队将尽快与您联系。',
    backHome: '返回首页',
    browseProducts: '继续浏览产品',
    contactSupport: '联系售后支持',
    nextStepsTitle: '接下来会发生什么',
    nextSteps: [
      '我们将在 1–2 个工作日内审核您的请求。',
      '如需更多信息，我们会主动与您联系。',
      '您可以继续浏览站点或通过电话/邮箱联系我们。',
    ],
    contactTitle: '需要立即协助？',
    contactPhoneLabel: '服务热线：',
    contactEmailLabel: '邮箱：',
  },
  about: {
    banner: {
      alt: '关于我们横幅',
      title: 'Zetok专注创新教育， 提供高品质套件与课程',
      image: require('@/assets/about/banner.png'),
    },
    mission: {
      title: '我们的使命',
      desc: '我们的使命是通过先进的人工智能技术，赋能教育，激发创新，培养未来的领导者和创新者。我们相信，通过提供高质量的教育工具和解决方案，可以帮助学生和教育工作者实现他们的潜力。',
      image: require('@/assets/about/mission.png'),
    },
    vision: {
      title: '我们的愿景',
      desc: '科技赋能教育，助力每个学生获取优质STEM资源，激发潜能，培养未来创新者与领导者。',
      image: require('@/assets/about/vision.png'),
    },
    products: {
      title: '我们的产品',
      tabs: ['套件', '课程', '激光设备'],
      items: [
        {
          title: '套件',
          desc: '我们提供多样化的STEM套件，包括人工智能、机器人学、编程和科学实验等，这些套件设计精良，易于使用，适合不同年龄段的学生。',
          image: require('@/assets/about/kits.png'),
        },
        {
          title: '课程',
          desc: '我们的课程由教育专家精心设计，旨在与套件相结合，提供全面的学习体验。课程内容涵盖基础概念到高级应用，适合不同水平的学习者。',
          image: require('@/assets/about/courses.png'),
        },
        {
          title: '激光设备',
          desc: '安全易用的激光切割/我们的激光切割和雕刻设备专为教育环境设计，安全、精确且易于操作。这些设备为学生提供了将创意转化为实体作品的机会。',
          image: require('@/assets/about/laser.png'),
        },
      ],
    },
    dealer: {
      banner: {
        alt: '加入我们，成为Zetok的经销商',
        title: '加入我们，成为Zetok的经销商',
        image: require('@/assets/about/dealer.png'),
      },
      intro: {
        title: '开拓教育新商机，共享创新成果！',
        desc: 'Zetok邀您共拓STEM教育新径，提供AI套件、激光设备等，激发学生创造力，诚邀加盟，共赢未来！',
        image: require('@/assets/about/dealer1.png'),
      },
      mission: {
        title: '我们的使命',
        items: [
          {
            title: '领先产品',
            desc: '获取市场上优质的STEA M教育工具。',
            image: require('@/assets/about/dealer-mission-1.png'),
          },
          {
            title: '丰厚回报',
            desc: '享受有竞争力的折扣和销售激励。',
            image: require('@/assets/about/dealer-mission-2.png'),
          },
          {
            title: '市场支持',
            desc: '提供营销资料和销售培训，助您快速打开市场。',
            image: require('@/assets/about/dealer-mission-3.png'),
          },
          {
            title: '品牌合作',
            desc: '与Zetok携手，共享品牌影响力和市场资源。',
            image: require('@/assets/about/dealer-mission-4.png'),
          },
        ],
      },
    },
    cooperation: {
      banner: {
        alt: '合作横幅',
        title: '产品合作',
        cta: '立即联系',
        ctaLink: '/about#contact',
        image: require('@/assets/about/coop-introbanner.png'),
      },
      intro: {
        title: '激发未来科学家和工程师的潜力',
        desc: '加入我们的STEM教育推广计划，获取专为教育工作者设计的特别优惠和产品试用。我们为课堂提供创新的STEM工具，以及独家折扣，助力您培养下一代的创新者和问题解决者。',
        image: require('@/assets/about/coop-introbanner1.png'),
      },
      stem: {
        title: '立即行动，开启STEM教育新篇章！',
        items: [
          {
            title: '免费产品试用',
            desc: '让您在购买前先行体验我们的工具。',
            image: require('@/assets/about/edu1.png'),
          },
          {
            title: '独家折扣',
            desc: '为为您的教室或学校提供经济实惠的STEM解决方案。',
            image: require('@/assets/about/edu2.png'),
          },
          {
            title: '教育资源',
            desc: '提供丰富的教学资源和课程计划，支持您的教学活动。',
            image: require('@/assets/about/edu3.png'),
          },
        ],
      },
      contact: {
        title: '联系我们',
        desc: '有任何问题或需求，欢迎与我们联系，我们将竭诚为您服务',
        image: require('@/assets/about/kites.png'),
      },
    },
    news: {
      banner: {
        alt: '新闻中心横幅',
        title: '新闻中心',
        image: require('@/assets/about/newsbanner.png'),
      },
      title: '新闻中心',
      tabs: [
        { key: 'company', label: '公司动态' },
        { key: 'industry', label: '行业动态' },
        { key: 'expo', label: '展会动态' },
      ],
      data: {
        company: [
          {
            id: 'company-1',
            title: '中泽推出全新课堂 AI 套件',
            date: '2025-04-22',
            image: 'https://picsum.photos/seed/news-company-1-zh/560/342',
          },
          {
            id: 'company-2',
            title: '与本地学校合作试点 STEM 项目',
            date: '2025-04-15',
            image: 'https://picsum.photos/seed/news-company-2-zh/560/342',
          },
          {
            id: 'company-3',
            title: '软件更新提升课堂管理体验',
            date: '2025-03-30',
            image: 'https://picsum.photos/seed/news-company-3-zh/560/342',
          },
          {
            id: 'company-4',
            title: '举办教师培训工作坊',
            date: '2025-03-18',
            image: 'https://picsum.photos/seed/news-company-4-zh/560/342',
          },
          {
            id: 'company-5',
            title: '经销网络覆盖更多区域',
            date: '2025-03-02',
            image: 'https://picsum.photos/seed/news-company-5-zh/560/342',
          },
          {
            id: 'company-6',
            title: '新课程系列聚焦真实项目实践',
            date: '2025-02-20',
            image: 'https://picsum.photos/seed/news-company-6-zh/560/342',
          },
          {
            id: 'company-7',
            title: '年度回顾凸显创新成果',
            date: '2025-02-05',
            image: 'https://picsum.photos/seed/news-company-7-zh/560/342',
          },
          {
            id: 'company-8',
            title: '社区公益计划将 STEM 带给青少年',
            date: '2025-01-25',
            image: 'https://picsum.photos/seed/news-company-8-zh/560/342',
          },
        ],
        industry: [
          {
            id: 'industry-1',
            title: '全球趋势：项目式学习在 STEM 的应用',
            date: '2025-04-10',
            image: 'https://picsum.photos/seed/news-industry-1-zh/560/342',
          },
          {
            id: 'industry-2',
            title: '教育中的 AI：涌现的最佳实践',
            date: '2025-03-25',
            image: 'https://picsum.photos/seed/news-industry-2-zh/560/342',
          },
          {
            id: 'industry-3',
            title: '新课程标准更强调动手能力',
            date: '2025-03-12',
            image: 'https://picsum.photos/seed/news-industry-3-zh/560/342',
          },
          {
            id: 'industry-4',
            title: '教育硬件更贴近课堂使用需求',
            date: '2025-02-28',
            image: 'https://picsum.photos/seed/news-industry-4-zh/560/342',
          },
          {
            id: 'industry-5',
            title: 'STEAM 项目在各学区持续推进',
            date: '2025-02-14',
            image: 'https://picsum.photos/seed/news-industry-5-zh/560/342',
          },
          {
            id: 'industry-6',
            title: '可持续发展项目走进 STEM 课堂',
            date: '2025-01-30',
            image: 'https://picsum.photos/seed/news-industry-6-zh/560/342',
          },
          {
            id: 'industry-7',
            title: '创客空间影响着创新学习方式',
            date: '2025-01-16',
            image: 'https://picsum.photos/seed/news-industry-7-zh/560/342',
          },
        ],
        expo: [
          {
            id: 'expo-1',
            title: '中泽亮相教育科技展',
            date: '2025-04-05',
            image: 'https://picsum.photos/seed/news-expo-1-zh/560/342',
          },
          {
            id: 'expo-2',
            title: '区域展会上展示学生项目成果',
            date: '2025-03-22',
            image: 'https://picsum.photos/seed/news-expo-2-zh/560/342',
          },
          {
            id: 'expo-3',
            title: '创客活动现场互动演示吸引关注',
            date: '2025-03-08',
            image: 'https://picsum.photos/seed/news-expo-3-zh/560/342',
          },
          {
            id: 'expo-4',
            title: '面向教师的可视化编程工作坊',
            date: '2025-02-21',
            image: 'https://picsum.photos/seed/news-expo-4-zh/560/342',
          },
          {
            id: 'expo-5',
            title: '新设备面向教育合作伙伴展示',
            date: '2025-02-09',
            image: 'https://picsum.photos/seed/news-expo-5-zh/560/342',
          },
        ],
      },
    },
  },
  finance: {
    contact: {
      success: '提交成功，我们将尽快与您联系',
      error: '提交失败，请稍后重试',
      networkError: '网络错误，请检查网络后重试',
    },
  },
  footer: {
    subscribePlaceholder: '您的手机号和邮箱地址',
    subscribe: '订阅',
    subscribeSuccess: '订阅成功',
    contact: {
      sales: '销售热线：+86 18379276683',
      service: '服务热线：+86 400 968 0598',
      email: '邮箱：sam@zz-steam.com',
      address: '地址：深圳福田八卦四路华晟达大厦A座',
    },
    icp: '隐私政策·用户协议 版权所有 © 中泽教育（深圳）有限公司 粤ICP备2024289240号-3',
  },
  solutions: {
    stem: {
      banner: {
        alt: 'STEM 教育解决方案横幅',
        title: ' STEM教育的创意引领',
        description:
          '面向 K12 我们专注创意STEM教育，激发求知，培养逻辑，点燃编程热情。',
        image: require('@/assets/solution/banner.png'),
      },
      intro: {
        title: '人工智能与编程教育',
        items: [
          {
            icon: require('@/assets/solution/icon1.png'),
            title: '易学易用',
            description: '图形化编程，新手秒上手，轻松打造专属AI项目。',
          },
          {
            icon: require('@/assets/solution/icon2.png'),
            title: '功能强大',
            description: '智能硬件，语音交互，创意无限。',
          },
          {
            icon: require('@/assets/solution/icon3.png'),
            title: '拓展性强',
            description: '接元件硬件，启想象，创无限。',
          },
          {
            icon: require('@/assets/solution/icon4.png'),
            title: '课程丰富',
            description: '配套课程，从基础到实践，助力学生构建知识体系。',
          },
        ],
      },
      scenes: {
        title: '了解我们的特色课程',
        items: [
          {
            tab: '学校教育',
            title: 'AI 学校教育',
            desc: '利用人工智能套件制作智能语音助手，在实践中激发兴趣，培养逻辑与编程能力，感受人工智能魅力。',
            image: require('@/assets/solution/tc1.png'),
          },
          {
            tab: '竞赛培训',
            title: '竞赛培训',
            desc: '智能套件助力机器人竞赛与科技创新，学生设计智能作品，提升协作与创新能力。',
            image: require('@/assets/solution/tc2.png'),
          },
          {
            tab: '家庭学习',
            title: '家庭学习',
            desc: '亲子学习人工智能项目，培养动手能力，增进关系，提升科技素养。',
            image: require('@/assets/solution/tc3.png'),
          },
        ],
      },
      split: {
        title: 'AI+教育：开启智慧学习新时代',
        desc: '利用人工智能技术，个性化学习路径，精准教学，让每个学生都能在知识的海洋中畅游无阻。',
        image: require('@/assets/solution/banner1.png'),
      },
      kits: {
        title: 'STEM 系列套件',
        images: [
          require('@/assets/solution/kits1.png'),
          require('@/assets/solution/kits2.png'),
          require('@/assets/solution/kits3.png'),
          require('@/assets/solution/kits4.png'),
        ],
      },
    },
    makerSpace: {
      banner: {
        alt: '创客空间解决方案横幅',
        title: '探索我们的创客空间',
        description:
          '在创客空间中，教育与创新技术相结合，为学生提供了一个实践和探索的平台',
        image: require('@/assets/solution/spacebanner.png'),
      },
      intro: {
        title: '全方位创客技能',
        items: [
          {
            icon: require('@/assets/solution/icon5.png'),
            title: '技术工具应用',
            desc: '图形化编程，轻松上手，初学者秒搭人工智能项目',
          },
          {
            icon: require('@/assets/solution/icon6.png'),
            title: '开放性和灵活性',
            desc: '创客空间，自由探索，释放创意的专属乐园。',
          },
          {
            icon: require('@/assets/solution/icon7.png'),
            title: '动手实践',
            desc: '动手实践，制作、实验、探索，开启学习之旅。',
          },
          {
            icon: require('@/assets/solution/icon8.png'),
            title: '协作学习',
            desc: '鼓励学生在团队中合作，培养团队协作和沟通能力。',
          },
        ],
      },
      scenes: {
        title: '创客空间应用场景',
        items: [
          {
            tab: '学校手工课程',
            title: '学校手工课程',
            desc: '作为手工制作、美术设计等课程的有力补充。',
            image: require('@/assets/solution/tc4.png'),
          },
          {
            tab: '创新实践社团',
            title: '创新实践社团',
            desc: '为学校的创新实践社团提供实践平台',
            image: require('@/assets/solution/tc5.png'),
          },
          {
            tab: '教育实验室',
            title: '教育实验室',
            desc: '适用于学校、大学或实验室，更新学习环境，为学生提供专业的激光雕刻机。',
            image: require('@/assets/solution/tc6.png'),
          },
        ],
      },
      split: {
        title: '创意实现的工具',
        desc: '利用激光切割机的精确切割能力和编程机器人的智能交互功能，学生们能够将抽象的创意转化为具体的实体作品',
        image: require('@/assets/solution/banner2.png'),
      },
      kits: {
        title: '创客系列套件',
        images: [
          require('@/assets/solution/kits5.png'),
          require('@/assets/solution/kits6.png'),
          require('@/assets/solution/kits7.png'),
          require('@/assets/solution/kits8.png'),
        ],
      },
    },
  },
  software: {
    banner: {
      alt: '软件页面横幅',
      title: 'Zetok软件中心',
      image: require('@/assets/software/banner.png'),
    },
    download: {
      title: '软件下载',
      items: [
        {
          key: 'lightmaker-app',
          icon: require('@/assets/software/s1.png'),
          name: 'Light maker App',
          buttonText: '下载移动端',
          link: '#',
        },
        {
          key: 'goodlaser-lightmaker',
          icon: require('@/assets/software/s2.png'),
          name: 'Good-laser Light maker',
          buttonText: '下载客户端',
          link: '#',
        },
        {
          key: 'zz-learning-app',
          icon: require('@/assets/software/s3.png'),
          name: '中泽教 学习平台app',
          buttonText: '下载移动端',
          link: '#',
        },
        {
          key: 'zz-learning-platform',
          icon: 'https://picsum.photos/seed/sw-app-4/88/88',
          name: '中泽科技学习平台',
          buttonText: '下载客户端',
          link: '#',
        },
      ],
    },
    intro: {
      'goodlaser-lightmaker': {
        header: {
          title: ' Light Maker 激光设备专用软件',
          desc: '集图形设计与设备控制于一体，为用户节省大量时间，提供了一体化的设计和激光控制解决方案。',
        },
        items: [
          {
            image: require('@/assets/software/s1.png'),
            title: '功能强大易于使用的设计系统',
            desc: '强大的创作软件，兼容JPG、DXF、AI、DST、PNG、BMP、TIF、SVG格式的高质量设计。 DWG、DXF、AI、DST、PNG、BMP、TIF、SVG 等。',
          },
          {
            image: require('@/assets/software/s2.png'),
            title: '专业性',
            desc: '专业的画图功能，满足一切制作需求。无论是复杂的设计还是简单的切割，都能轻松应对。',
          },
          {
            image: require('@/assets/software/s3.png'),
            title: '便于操作',
            desc: '拥有用户友好的界面，并支持多种激光设备。易用性、多功能界面以及高效的切割和雕刻处理能力',
          },
        ],
      },
      'lightmaker-app': {
        header: {
          title: ' Light Maker 激光设备专用软件',
          desc: '集图形设计与设备控制于一体，为用户节省大量时间，提供了一体化的设计和激光控制解决方案。',
        },
        items: [
          {
            image: require('@/assets/software/s1.png'),
            title: '功能强大易于使用的设计系统',
            desc: '强大的创作软件，兼容JPG、DXF、AI、DST、PNG、BMP、TIF、SVG格式的高质量设计。 DWG、DXF、AI、DST、PNG、BMP、TIF、SVG 等。',
          },
          {
            image: require('@/assets/software/s2.png'),
            title: '专业性',
            desc: '专业的画图功能，满足一切制作需求。无论是复杂的设计还是简单的切割，都能轻松应对。',
          },
          {
            image: require('@/assets/software/s3.png'),
            title: '便于操作',
            desc: '拥有用户友好的界面，并支持多种激光设备。易用性、多功能界面以及高效的切割和雕刻处理能力',
          },
        ],
      },
      'zz-learning-app': {
        header: {
          title: 'Zetok云平台',
          desc: '云平台是一个创新的教育管理工具，旨在为教师、学生和学校提供一站式的解决方案。通过我们的云平台，您可以轻松完成作业收发、设备监控、报修和参数配置等任务。',
        },
        items: [
          {
            image: require('@/assets/software/c1.png'),
            title: '操作便利',
            desc: '一键制作：内置图库和参数配置，支持一键制作，简化操作流程。设备监控：实时监控设备状态，确保教学活动顺利进行。',
          },
          {
            image: require('@/assets/software/c2.png'),
            title: '统一管理',
            desc: '设备并联：支持创客教室其他设备并联，一键管理功能，提高管理效率。',
          },
          {
            image: require('@/assets/software/c3.png'),
            title: '实时监控',
            desc: '设备状态：实时了解设备的运行状态，出现故障及时报修。维护保养：系统根据设备运行时长和使用频率，定期提示进行维护保养，延长设备使用寿命，提高切割质量。',
          },
        ],
      },
      'zz-learning-platform': {
        header: {
          title: 'Zetok学习平台',
          desc: 'Zetok学习平台是一个创新的在线学习工具，旨在为学生和教师提供一个全面的科教软件解决方案。无论是在移动设备还是电脑上，用户都可以轻松访问和使用我们的平台。',
        },
        items: [
          {
            image: require('@/assets/software/pc1.png'),
            title: '智能便捷，新手无忧',
            desc: '内设丰富图库与预设参数，支持一键制作，新手可快速上手。 手机端新手指引详细，助力初学者轻松掌握操作方法。云服务支持后台实时监控教室设备运行状态，确保教学过程安全高效。',
          },
          {
            image: require('@/assets/software/pc2.png'),
            title: 'AI创作',
            desc: '一键造物和AI生图的特点在于它们能够简化设计流程，提高创作效率。用户只需输入简单的指令或上传参考图像，AI就能自动生成高质量、方便切割的素材。',
          },
          {
            image: require('@/assets/software/pc3.png'),
            title: '高效学习新体验',
            desc: 'Zetok学习平台集课程学习、图形设计、激光切割加工于一体，操作简单便捷，用户可快速上手。 首页采用卡片化设计，清晰区分课程学习、图形设计、激光切割加工等模块，让学习、设计、加工无缝衔接，大幅提升学习效率。',
          },
        ],
      },
    },
  },
  product: {
    farm: {
      banner: {
        alt: '智能农场横幅',
        title: '智能农场学习套件',
        btnText:'前往购买',
        description: '项目式教学 | 编程+硬件+AI | 中小学适用',
        image: require('@/assets/product/farm/banner.png'),
      },
      sections: {
        courseTitle: '项目课程内容',
        resourceTitle: '教学资源',
        equipmentsTitle: '器材配置',
      },
      courses: [
        {
          bg: '#FBBC05',
          txt: '#fff',
          title: '课程内容丰富多样',
          desc: '12课由浅入深：从温度检测到智能灌溉、温控，一站式进阶。',
          image: require('@/assets/product/farm/education1.png'),
        },
        {
          bg: '#4285F4',
          txt: '#fff',
          title: '跨学科知识融合',
          desc: '每个项目都涉及编程、电子硬件、机械结构等多学科知识，有助于学生在实践中综合运用所学，提升跨学科思维能力。',
          image: require('@/assets/product/farm/education2.png'),
        },
        {
          bg: '#EA4335',
          txt: '#fff',
          title: '生活化主题',
          desc: '以智能农场为主题，贴近学生生活，容易激发学生的学习兴趣和参与热情。',
          image: require('@/assets/product/farm/education3.png'),
        },
      ],
      resources: [
        {
          title: '完整的教学PPT和讲义',
          desc: '16节课的教学PPT和讲义，内容与教学项目紧密对应，为教师提供了丰富的教学素材，减轻了备课负担。',
          image: require('@/assets/product/farm/edu1.png'),
        },
        {
          title: '项目式课程的组装视频',
          desc: '视频资料能够直观展示项目搭建过程，帮助学生更好地理解和掌握操作步骤，提高学习效率。',
          image: require('@/assets/product/farm/edu2.png'),
        },
        {
          title: '辅助教学资料',
          desc: '讲义等辅助资料可以为学生提供更详细的学习指导，方便学生课后复习和自学。',
          image: require('@/assets/product/farm/edu3.png'),
        },
      ],
      equipments: [
        {
          title: 'RGB灯带',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'DS1307时钟模块',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'DHT11温湿度传感器',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: '人体感应传感器',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'LED照明模块',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: '风扇模块',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: '槽型光耦开关',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: '按键模块',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: '掌控板',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: '拓展版',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    home: {
      banner: {
        alt: '智能家居学习套件',
        title: '智能家居学习套件',
        btnText:'前往购买',
        description: '编程与AI启蒙 | 项目式教学 | 中小学科技课堂首选',
        image: require('@/assets/product/home/banner.png'),
      },
      resourcesTitle: '智能家居入门套件的优势',
      resources: [
        {
          title: '资源丰富',
          desc: '提供完整的教学资源，方便教师教学和学生学习。',
          image: require('@/assets/product/home/adv1.png'),
        },
        {
          title: '跨学科融合',
          desc: '每个项目都涉及编程、电子硬件、机械结构等多学科知识，有助于学生在实践中综合运用所学，提升跨学科思维能力。',
          image: require('@/assets/product/home/adv2.png'),
        },
        {
          title: '课后拓展任务',
          desc: '延伸任务与跨学科应用建议，促进探究与创作。',
          image: require('@/assets/product/home/adv3.png'),
        },
      ],
      course: {
        title: '配套的课程',
        desc: '包含12项精品项目课程，内容涵盖智能家居的多个方面，如电子门铃、调光门前灯、感应车库、密码门禁、气体预警、防盗报警、绚丽彩灯、音乐氛围灯、日光检测、室温检测和温控风扇等。',
        image: require('@/assets/product/home/banner2.png'),
      },
      scenesTitle: '多种应用场景',
      scenes: [
        {
          title: '课堂教学',
          image: require('@/assets/product/home/c1.png'),
        },
        {
          title: '独立创意开发',
          image: require('@/assets/product/home/c2.png'),
        },
        {
          title: '家庭亲子互动',
          image: require('@/assets/product/home/c3.png'),
        },
        {
          title: '活动展示',
          image: require('@/assets/product/home/c4.png'),
        },
      ],
      equipmentsTitle: '器材配置',
      equipments: [
        {
          title: 'RGB灯带',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'DS1307时钟模块',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'DHT11温湿度传感器',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: '人体感应传感器',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'LED照明模块',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: '风扇模块',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: '槽型光耦开关',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: '按键模块',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: '掌控板',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: '拓展版',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    factory: {
      banner: {
        alt: '智能工厂横幅',
        title: '智能工厂学习套件',
        btnText:'前往购买',
        description: ` · 传感/控制/驱动全覆盖 <br>
 · 模拟真实产线<br>
 · 培养“未来工程师”`,
        image: require('@/assets/product/factory/banner.png'),
      },
      resourcesTitle: '产品的特点',
      resources: [
        {
          title: '工业4.0核心体验',
          desc: '学生在模拟产线练传感、控制、驱动、数据管理。',
          image: require('@/assets/product/factory/tc1.png'),
        },
        {
          title: '项目式学习',
          desc: '包含编程教程，以及12节带PPT的课程，方便用户学习。',
          image: require('@/assets/product/factory/tc2.png'),
        },
        {
          title: '模拟真实场景',
          desc: '智能机械臂、自动分类系统、智能仓库，模拟物流库存管理，开启STEM实践之旅。',
          image: require('@/assets/product/factory/tc3.png'),
        },
      ],
      intro: {
        title: '产品简介',
        desc: '智能工厂学习套装是一款结合编程、电子硬件、机械结构、激光切割及人工智能科普学习的项目式教学套件，适用于中小学学生使用和教学。以“智慧制造·创享未来”为主题，通过模拟生产环境，培养学生的科学探究、工程设计、编程控制及协同创新能力。',
        bg: require('@/assets/product/factory/product.png'),
      },
      course: {
        title: '配套的课程',
        desc: '12项精品课程：涵盖智能工厂入门、生产流程认知、传感器应用、机械驱动基础、输送系统搭建、自动分拣、工位协作控制、装配机械手、智能分拣等主题。 控制与数据采集等主题设计项目式课程，强调实操与系统训练。',
        image: require('@/assets/product/factory/course.png'),
      },
      equipmentsTitle: '器材配置',
      equipments: [
        {
          title: 'RGB灯带',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'DS1307时钟模块',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'DHT11温湿度传感器',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: '人体感应传感器',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'LED照明模块',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: '风扇模块',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: '槽型光耦开关',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: '按键模块',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: '掌控板',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: '拓展版',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    kits: {
      laserSteam: {
        banner: {
          alt: '激光切割 STEAM 套件 横幅',
          title: '激光切割STEAM套件',
          btnText:'前往购买',
          description: '一站式培养创新思维与团队协作的智造教育解决方案',
          image: require('@/assets/product/laser-steam/banner.png'),
        },
        resourcesTitle: '激光切割STEAM套件的优势',
        resources: [
          {
            title: '多元智能理论',
            desc: '基于多元智能理论，课程培养创造力、批判思维、问题解决、沟通协作能力。',
            image: require('@/assets/product/laser-steam/adv1.png'),
          },
          {
            title: '项目式学习',
            desc: '通过项目式学习，学生可以在实践中学习，提高学习效率和兴趣。',
            image: require('@/assets/product/laser-steam/adv2.png'),
          },
          {
            title: 'STEAM教育',
            desc: '课程内容融合了科学、技术、工程、艺术和数学等多学科知识，帮助学生建立跨学科思维。',
            image: require('@/assets/product/laser-steam/adv3.png'),
          },
        ],
        teach: {
          title: '配套详细教学',
          tabs: [
            { key: 'cutter', label: '激光切割机' },
            { key: 'lesson', label: '配套课程' },
            { key: 'material', label: '教学材料' },
            { key: 'software', label: '软件' },
          ],
          images: {
            cutter: require('@/assets/product/laser-steam/cutter.png'),
            lesson: require('@/assets/product/laser-steam/lesson.png'),
            material: require('@/assets/product/laser-steam/material.png'),
            software: require('@/assets/product/laser-steam/software.png'),
          },
        },
        aiBanner: {
          title: 'AI教育，智慧启航',
          desc: '结合STEAM教育，融入AI元素，打造全方位学习体验。',
        },
        equipmentsTitle: '器材配置',
      },
      // 逐梦科学套件（Dream Science Kit）
      dreamScience: {
        banner: {
          alt: '逐梦科学套件 横幅',
          title: '奇妙科学宝盒（逐梦科学套件）',
          description: '低科学观念| 科学思维| 探究实践| 态度责任',
          image: require('@/assets/product/dream-science/banner.png'),
        },
        resourcesTitle: '套件内容',
        resources: [
          {
            title: '科学实验材料',
            desc: '用于完成各种科学实验和项目。',
            image: require('@/assets/product/dream-science/kits1.png'),
          },
          {
            title: '教学资源',
            desc: '包括教学PPT和讲义，支持一个学期的教学活动，内容与教学项目及知识点紧密对应。',
            image: require('@/assets/product/dream-science/kits2.png'),
          },
          {
            title: '组装视频和讲义',
            desc: '辅助教学资料，帮助学生更好地理解和掌握操作步骤。',
            image: require('@/assets/product/dream-science/kits3.png'),
          },
        ],
        objectivesTitle: '教学目标',
        objectives: [
          {
            title: '科学探究能力',
            desc: '提出问题、制定计划、收集与分析数据',
            image: require('@/assets/product/dream-science/education1.png'),
          },
          {
            title: '工程实践能力',
            desc: '动手搭建与测试，迭代改进方案',
            image: require('@/assets/product/dream-science/education2.png'),
          },
          {
            title: '跨学科融合',
            desc: '结合数学、物理、艺术完成项目',
            image: require('@/assets/product/dream-science/education3.png'),
          },
        ],
        intro: {
          title: '适用人群',
          description:
            '中小学生：适合不同年龄段的学生，有助于提升他们的科学素养和实践能力。教师：为教师提供教学资源和指导，帮助他们更好地开展教学活动。',
          image: require('@/assets/product/dream-science/banner1.png'),
          alt: '介绍板块图片',
        },
      },
    },
    // 查看所有套件页面
    kitsViewAll: {
      banner: {
        alt: '查看所有套件 横幅',
        title: '套件系列',
        image: require('@/assets/product/kitsall/banner.png'),
      },
      contentTitle:
        '以项目为核心，学生通过完成各种项目任务，培养综合运用知识解决问题的能力。',
      moreText: '了解更多',
      items: [
        {
          image: require('@/assets/product/kitsall/kits1.png'),
          title: '智能农场学习套件',
          desc: '以项目为核心，激发学生创造力和动手实践能力，培养解决实际问题的技巧。',
          link: '/products/laser-steam',
        },
        {
          image: require('@/assets/product/kitsall/kits2-1.png'),
          title: '智能家居学习套件',
          desc: '结合编程、电子硬件、机械结构、激光切割和人工智能科普，提供全面学习体验。',
          link: '/products/dream-science',
        },
        {
          image: require('@/assets/product/kitsall/kits2-2.png'),
          title: '智能交通学习套件',
          desc: '是一款集编程、电子硬件、机械结构、激光切割及人工智能科普于一体的项目式教学套件。',
          link: '/products',
        },
        {
          image: require('@/assets/product/kitsall/kits2-3.png'),
          title: '智能工厂学习套件',
          desc: '涵盖人工智能基础知识和实际案例，循序渐进引导学生学习，帮助其系统构建知识体系。',
          link: '/products/traffic',
        },
        // {
        //   image: require('@/assets/product/kitsall/kits2-4.png'),
        //   title: '激光切割STEAM套件',
        //   desc: '激光切割STEAM课程套件以多元智能理论、STEAM教育理念和项目式学习理论等为指导。',
        //   link: '/products/home',
        // },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: '逐梦科学套件',
        //   desc: '逐梦科学套件能够满足不同学习阶段的需求，激发学生的科学兴趣和探索精神。',
        //   link: '/products/farm',
        // },
      ],
    },
    traffic: {
      banner: {
        alt: '智能交通横幅',
        title: '智能交通学习套件',
        btnText:'前往购买',
        description: `12 个项目式课程 
  <br>· 图形化/Python 双编程  <br>
 · 真实场景模拟<br>
 · 即开即教`,
        image: require('@/assets/product/traffic/banner.png'),
      },
      resourcesTitle: '产品的特点',
      resources: [
        {
          title: '科学探究与创新',
          desc: '学生用电子模块与机械结构搭建智能交通系统',
          image: require('@/assets/product/traffic/traffic1.png'),
        },
        {
          title: '教育性强',
          desc: '可构建智能路灯、交通灯、人行横道和停车场等项目，帮助学生了解智能交通概念。',
          image: require('@/assets/product/traffic/traffic2.png'),
        },
        {
          title: '丰富资源',
          desc: '配套完整教学资源，包括12节课的PPT和讲义、项目式课程的组装视频和讲义等辅助资料。',
          image: require('@/assets/product/traffic/traffic3.png'),
        },
      ],
      intro: {
        title: '产品简介',
        desc: '智能交通中小学套件以“智慧出行”和“交通安全”为主题，结合电子控制、传感器等技术，引导学生亲手设计并搭建智能交通系统，模拟真实交通场景，培养科学素养和创新能力。',
        bg: require('@/assets/product/traffic/banner1.png'),
      },
      course: {
        title: '配套的课程',
        desc: '包含交通感知与控制基础、信号联动、路径规划等主题的项目式课程，适配不同阶段与课时安排。',
        image: require('@/assets/product/traffic/course.png'),
      },
      equipmentsTitle: '器材配置',
      equipments: [
        {
          title: 'RGB灯带',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'DS1307时钟模块',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'DHT11温湿度传感器',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: '人体感应传感器',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'LED照明模块',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: '风扇模块',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: '槽型光耦开关',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: '按键模块',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: '掌控板',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: '拓展版',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    banner: {
      alt: '产品主页横幅',
      title: 'Zetok 产品与解决方案',
      description: '套件、课程、设备与软件一体化，支持项目式学习',
      image: 'https://picsum.photos/id/1069/1600/900',
    },
    courses: {
      banner: {
        alt: '课程组件横幅',
        title: '四大课程体系',
        description:
          '课程内容涵盖科学、技术、工程、艺术和数学（STEAM）等多个学科领域，促进学生跨学科知识的整合和应用。',
        image: require('@/assets/product/courses/banner.png'),
      },
      design: {
        title: '了解我们的特色课程',
        nav: ['年龄3-6岁', '年龄6-12岁', '年龄8-13岁', '年龄9-15岁'],
        entries: [
          {
            title: '科学探索体系·幼儿（6门课）',
            desc: '通过生活中常见的现象，利用科学教具进一步探索，从而了解事物发展的规律和原理。',
            image: require('@/assets/product/courses/courses1.png'),
          },
          {
            title: ' STEANM创客体系青少年（3门课）',
            desc: '发挥自己的创意，能够运用设备，动手实践，将创意转化成作品。',
            image: require('@/assets/product/courses/courses2.png'),
          },
          {
            title: '激光切割课程体系（3门课）',
            desc: '能利用设备切割不同的结构件，组装成立体的结构，并对结构进行美化。编程能力：了解编程判断的逻辑与原理。',
            image: require('@/assets/product/courses/courses3.png'),
          },
          {
            title: '人工智能课程体系（4门课）',
            desc: '使用设备工具，设计制作作品的外观，并通过编程使作品变得智能化，简单化，并能解决生活中遇到的问题。 ',
            image: require('@/assets/product/courses/courses4.png'),
          },
        ],
        detailsTitle: '课程优势',
        details: [
          {
            title: '实践操作性强',
            description: '动手实践，理论变技能',
            image: require('@/assets/product/courses/icon1.png'),
          },
          {
            title: '创新思维培养',
            description: '动手设计，创意解决问题',
            image: require('@/assets/product/courses/icon2.png'),
          },
          {
            title: '项目驱动学习',
            description: '以项目驱动学习，在实践中掌握知识',
            image: require('@/assets/product/courses/icon3.png'),
          },
          {
            title: '科技前沿探索',
            description: '紧跟科技前沿，学习智能套件应用',
            image: require('@/assets/product/courses/icon4.png'),
          },
          {
            title: '系统化教学',
            description: '课程内容由浅入深，从基础理论到实践操作',
            image: require('@/assets/product/courses/icon5.png'),
          },
          {
            title: '趣味性与挑战性并存',
            description: '趣味激发兴趣，挑战激发潜能，探索中实现成长。 ',
            image: require('@/assets/product/courses/icon6.png'),
          },
        ],
      },
      ai: {
        title: '人工智能系列课程',
        items: [
          {
            name: '智能农场',
            image: require('@/assets/product/courses/courses5.png'),
          },
          {
            name: '智能家居',
            image: require('@/assets/product/courses/courses6.png'),
          },
          {
            name: '智能交通',
            image: require('@/assets/product/courses/courses7.png'),
          },
          {
            name: '智能工厂',
            image: require('@/assets/product/courses/courses8.png'),
          },
        ],
      },
      aiBanner: {
        alt: 'AI 课程横幅',
        text: '项目驱动，跨学科融合，培养动手、合作与解决问题能力。安全与个性并重，成果展示提升成就感，助力学生成长。',
        image: require('@/assets/product/courses/banner1.png'),
      },
    },
    laser: {
      banner: {
        alt: '激光产品',
        title: 'Good Laser 激光产品',
        description: '安全易用、面向教育场景的激光切割/雕刻设备与解决方案',
        image: require('@/assets/product/laser/banner.png'),
      },
      advantagesTitle: '我们的优势',
      extraNote: {
        light640_640:
          '出色的切割和雕刻作品\n多种机型，多种激光功率配置，满足不同应用的需求\n激光类型:直流C02  激光功率:60W-130W',
      },
      center: {
        title: '产品中心',
        laser_accessories:'可支持配件',
        air_purifier_name:'空气净化器',
        description:
          '提供激光设备搭配方案根据学校不同程度的教学情况，Zetok推出了四款官方激光设备方案，学校可按实际教学需求进行选购。',
        tabs: [
          {
            key: 'light530',
            label: 'Light 530',
            images: [
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '高品质高精度激光',
                bgColor: '#4285F4',
                description:
                  '加厚的高品质二氧化碳激光管，波长10640nm，提供55W高质量二氧化碳激光，最大切割厚度可达20mm(亚克力)，工作速度达600mm/s，重复定位精度0.025mm的配置，可快速精准地切割和雕刻出精致的创意作品。',
                image: require('@/assets/product/laser/light530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '一体化三重废气过滤系统箱',
                bgColor: '#FFBC0C',
                description:
                  '过滤网，活性炭和UV臭氧层的多种烟尘过滤系统风箱一体化设计的构造，不仅更清洁环保，同时放置产品也更便捷和紧凑，无需另外单独购买过滤箱和占用更多空间。',
                image: require('@/assets/product/laser/light530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '最高优先标准安全防护',
                bgColor: '#34A853',
                description:
                  '通过SGS实验室最高安全测试，FDA认证的I类激光产品，有独 特的安全及工作状态指示灯设计，可直观、清晰的掌握机器的 运行状态。',
                image: require('@/assets/product/laser/light530-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '操作简单且功能强大的激光切割系统',
                bgColor: '#0F9D58',
                description:
                  '·可针对不同的加工材料设置不同的加工工艺参数，如:切割，深雕，浅雕，扫描等。 ·丰富的图纸素材，提高使用者的设计效率。 ·摄像头支持定点拍摄，辅助设计图形，让创意变为现实。',
                image: require('@/assets/product/laser/light530-4.png'),
              },
            ],
          },
          {
            key: 'light640',
            label: 'Light 640',
            images: [
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
            ],
            models: [
              {
                key: '640',
                label: 'Light 640',
                image: require('@/assets/product/laser/640.png'),
              },
              {
                key: '960',
                label: 'Light 960',
                image: require('@/assets/product/laser/960.png'),
              },
              {
                key: '1390',
                label: 'Light 1390',
                image: require('@/assets/product/laser/1390.png'),
              },
              {
                key: '1610',
                label: 'Light 1610',
                image: require('@/assets/product/laser/1610.png'),
              },
            ],
            modelAdvantages: {
              640: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '工作区域',
                  bgColor: '#4285F4',
                  description: `Light640 (600*400mm)
                              <br>Light960 (900*600mm)
                              <br>Light1390 (1300*900mm)
                              <br>Light1610(1600*1000mm)`,
                  image: require('@/assets/product/laser/640-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '高效自动对焦+红点定位',
                  bgColor: '#FFBC0C',
                  description:
                    '自动对焦功能可以在切割和雕刻前快速准确对焦定位。加上红点定位的光束，可实时查看工作位置。这样，恒好激光640系列为您节省了大量的切割和雕刻时间，并为您带来更好的切割和雕刻效果。',
                  image: require('@/assets/product/laser/640-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '开放式后门设计',
                  bgColor: '#34A853',
                  description:
                    '开放式后门的设计允许放置无限制长度的切割和雕刻材料， 600mmx∞长度的板材使您的工作更加方便，受到的限制更少。',
                  image: require('@/assets/product/laser/640-3.png'),
                },
              ],
              960: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '出色的切割和雕刻作品',
                  bgColor: '#4285F4',
                  description:
                    ' 激光切割机搭载宽敞的激光切割平台，对木材和亚克力的加工已达到企业级加工精度与效率。 能够批量生产激光工艺精品，助力企业生产力与量产效能飞跃提升。',
                  image: require('@/assets/product/laser/960-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '搭载优质激光管与精密组件',
                  bgColor: '#FFBC0C',
                  description:
                    '多样化的产品线，可以根据实际需求选择不同的激光类型和加工速度，满足各种生产要求。 为木材、玻璃、亚克力等材料加工提供了无限可能。',
                  image: require('@/assets/product/laser/960-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '严苛光质量测试，品质保证',
                  bgColor: '#34A853',
                  description:
                    '开通过严格的测试、精确的光路控制和超过 5 次的切割和雕刻试验保证选择具有稳定一致光输出的顶级 CO2 激光管。凭借出色的功率稳定性和精细的激光光斑，可实现均匀的雕刻，甚至可雕刻出复杂的细节。',
                  image: require('@/assets/product/laser/960-3.png'),
                },
              ],
              1390: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '全面&先进的安全功能',
                  bgColor: '#4285F4',
                  description: `1. 紧急停止
<br>2. 报警灯 
<br>3. 防水开关 
<br>4. 接地线 
<br>5. 内置热探测器警报在机器异常活动时自动开启
<br>6. 翻盖保护
<br>7. 钢化玻璃材质耐用保护窗`,
                  image: require('@/assets/product/laser/1390-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '经久耐用，品质卓越',
                  bgColor: '#FFBC0C',
                  description: `1.非常适合单件项目或大规模生产。
<br>2.工作区域选择范围广，从 600 x 400MM到 1600 x 1000MM。
<br>3.无与伦比的雕刻速度。
<br>4.由行业专家设计。
<br>5.是个性化、教育和工业应用的理想之选。`,
                  image: require('@/assets/product/laser/1390-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '通过智能监控优化生产',
                  bgColor: '#34A853',
                  description:
                    '专为保护敏感的设备组件（轴、激光头、光学元件、镜头）免受灰尘和污垢侵袭而开发，即使在大量使用的情况下，也能确保多年无故障运行。',
                  image: require('@/assets/product/laser/1390-3.png'),
                },
              ],
              1610: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '高效自动对焦+红点定位',
                  bgColor: '#4285F4',
                  description:
                    '自动对焦功能可以在切割和雕刻前快速准确对焦定位。加上红点定位的光束，可实时查看工作位置。这样， Light 1610为您节省了大量的切割和雕刻时间，并为您带来更好的切割和雕刻效果。',
                  image: require('@/assets/product/laser/1610-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '出色的切割和雕刻作品',
                  bgColor: '#FFBC0C',
                  description:
                    '激光切割机搭载宽敞的激光切割平台，对木材和亚克力的加工已达到企业级加工精度与效率。 能够批量生产激光工艺精品，助力企业生产力与量产效能飞跃提升。',
                  image: require('@/assets/product/laser/1610-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '经久耐用，品质卓越',
                  bgColor: '#34A853',
                  description: `1.非常适合单件项目或大规模生产。 
<br>2.工作区域选择范围广，从 600 x 400MM到 1600 x 1000MM。
<br>3.无与伦比的雕刻速度。 
<br>4.由行业专家设计。 
<br>5.是个性化、教育和工业应用的理想之选。`,
                  image: require('@/assets/product/laser/1610-3.png'),
                },
              ],
            },
          },
          {
            key: 'lightblue530',
            label: 'Light Blue 530',
            images: [
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '便携型蓝光雕刻机',
                bgColor: '#4285F4',
                description:
                  '蓝光雕刻机造型时尚、现代、紧凑，适合摆放在任何家庭、学校或工作室空间。金属机身搭配亚克力盖子的精妙组合。让这款小巧的机器可以完美地摆放在任何桌子上，同时还为其强大的20W/切割表现更优。',
                image: require('@/assets/product/laser/blue530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '封闭式加工，隔离避免伤害',
                bgColor: '#FFBC0C',
                description:
                  '蓝光雕刻机是全封闭式的，如果在执行任务时打开盖子，它会自动暂停。如果发生紧急情况，只需一个开关即可立即关闭机器。适合家庭和学校使用。',
                image: require('@/assets/product/laser/blue530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '多材质加工，支持上百种加工材料',
                bgColor: '#34A853',
                description:
                  '定制任何独特形状或风格的动态产品系列，添加配件以实现更多不同形状的材料雕刻，如杯子和圆形物体，非常适合您的小型企业需求。',
                image: require('@/assets/product/laser/blue530-3.png'),
              },
            ],
          },
          {
            key: 'markm20',
            label: 'Mark M20',
            images: [
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '多样化应用场景',
                bgColor: '#4285F4',
                description:
                  '该设备适用于多种行业，包括珠宝雕刻、个性化物件、零件识别等，能满足从珠宝、香水瓶到小型工业标牌等各种用途的定制雕刻。',
                image: require('@/assets/product/laser/m20.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '教育领域的创新应用',
                bgColor: '#FFBC0C',
                description:
                  'Mark M20设备将工业级精度引入教育领域，成为科创教育的“全能助手”，培养学生从基础打标技能到复杂项目开发的能力。',
                image: require('@/assets/product/laser/m20-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '紧凑与现代化',
                bgColor: '#34A853',
                description:
                  'Mark M20激光打标机设计紧凑现代，占地面积小，噪音低，视窗大，满足高耐用性需求。其时尚外观符合安全标准，适用于教育机构、公共零售环境。',
                image: require('@/assets/product/laser/m20-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '数秒内完成打标',
                bgColor: '#0F9D58',
                description:
                  'Mark即使是选用最小的字体，也能在几秒钟内完成精确打标。这种无与伦比的速度与我们的激光应用软件LightMaker简化后的工作流程和效率相结合，可确保您的生产率得到显著提高。',
                image: require('@/assets/product/laser/m20-4.png'),
              },
            ],
          },
          {
            key: 'accessories',
            label: '配件',
            images: [
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
            ],
            advantages: [
              {
              description: `
                  · 适用场所：适用于所有会产生烟雾、异味、粉尘、有毒有害气体等空气污染的场所。
              <br>· 应用领域：涵盖电子电器、玩具制造、精密五金、医疗等领域。
              <br>· 设计特点：采用可变式的单、双工位设计。
              <br>· 过滤装置：配备多层过滤装置。
              <br>· 风量调节：可根据废气产生量对风量大小进行无极调节。
              <br>· 净化效果：能有效地吸附和过滤，净化率高达 99.97%。
              <br>· 空气排放：净化处理后的洁净空气可直接在室内释放。
              `,
                image: require('@/assets/product/laser/accessories1.png'),
              },
              {
                description: `· 设备类型：辅助激光切割 / 雕刻机器加工的设备.
                     <br>· 用途：实现工件旋转运动。
<br>· 适配加工对象：圆柱状、管状等物体。
<br>· 拓展功能：使激光切割 / 雕刻机器从只能加工平面板材，拓展到可对圆柱体进行加工。`,
                image: require('@/assets/product/laser/accessories2.png'),
              },
              {
                description: `


· 高效成型机，提供精确的成型加工。
<br>· 数控系统控制，操作简便。
<br>· 多种成型模具可选。
<br>· 快速装夹系统，提高工作效率。
<br>· 安全防护装置齐全。
<br>· 适用于多种材料成型加工。
`,
                image: require('@/assets/product/laser/accessories3.png'),
              },
            ],
          },
        ],
      },
    },
  },
  support: {
    afterSales: {
      banner: {
        alt: '教程下载横幅',
        title: '教程下载',
        image: require('@/assets/after/banner.png'),
      },
      downloadText: '下载教程',
      items: [
        {
          id: 'mk-1',
          name: '智趣农场',
          image: 'https://picsum.photos/seed/as-farm1/588/391',
          link: '#',
        },
        {
          id: 'mk-2',
          name: '智能家居',
          image: 'https://picsum.photos/seed/as-home1/588/391',
          link: '#',
        },
        {
          id: 'mk-3',
          name: '智趣交通',
          image: 'https://picsum.photos/seed/as-traffic1/588/391',
          link: '#',
        },
        {
          id: 'mk-4',
          name: '智能工厂',
          image: 'https://picsum.photos/seed/as-factory1/588/391',
          link: '#',
        },
        {
          id: 'mk-5',
          name: '创客空间',
          image: 'https://picsum.photos/seed/as-makerspace1/588/391',
          link: '#',
        },
        {
          id: 'mk-6',
          name: '机器人课程',
          image: 'https://picsum.photos/seed/as-robot1/588/391',
          link: '#',
        },
        {
          id: 'mk-7',
          name: 'AI 教程',
          image: 'https://picsum.photos/seed/as-ai1/588/391',
          link: '#',
        },
        {
          id: 'mk-8',
          name: '物联网教程',
          image: 'https://picsum.photos/seed/as-iot1/588/391',
          link: '#',
        },
      ],
    },
  },
};
